export class CulturalInterpreterAccessMapper {
    public static toLabel(type?: string | null): string {
        switch (type) {
            case 'yes_interpreter': {
                return 'Ja, es gibt Gebärdendolmetscherinnen/Gebärdendolmetscher';
            }
            case 'no_requested': {
                return 'Nein, es gibt keine Gebärdendolmetscherinnen/Gebärdendolmetscher, diese können aber angefragt werden';
            }
            case 'no_interpreter': {
                return 'Nein, es gibt keine Gebärdendolmetscherinnen/Gebärdendolmetscher';
            }
            case undefined:
            case null:
            default:
                return 'Nicht bekannt';
        }
    }
}
